__turbopack_context__.v({
  "className": "playfair_display_c126fd5d-module__5AdCca__className",
});
